module.exports = __webpack_public_path__ + "static/media/reglamento.ea3b11e0.jpg";